import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { ShieldOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logout as apiLogout } from '@/services/api/authService';
import { useAppDispatch } from '@/store';
import { logout } from '@/store/slices/authSlice';

/**
 * Shown when an engineer hits a page they are not permitted to access.
 * No fallback redirect — access is denied explicitly.
 */
const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    await apiLogout();
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 440, textAlign: 'center' }}>
        <ShieldOff size={40} style={{ color: '#94a3b8', marginBottom: 16 }} />
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Access denied
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          You do not have permission to open this page. Ask a Super Admin to enable the required
          pages for the Engineer role in Users → Permissions.
        </Typography>
        <Button variant="outlined" color="inherit" onClick={handleLogout}>
          Sign out
        </Button>
      </Paper>
    </Box>
  );
};

export default AccessDenied;
